export const SESSION = 'SESSION';
export const MONTHLY = 'MONTHLY';
export const WEEKLY = 'WEEKLY';

export const BILLING_PAYMENT_TYPES = [
    {
        data: SESSION,
        view: 'Per Session'
    },
    {
        data: WEEKLY,
        view: 'Per Week'
    },
    {
        data: MONTHLY,
        view: 'Per Month'
    }
];


// WEBPACK FOOTER //
// ./src/constants/billing-payment-type.js